const formsList = [
  {
    type: "form",
    category: ["all", "purchase", "lease"],
    formNumber: "create-deal-sheet",
    title: "Creating your Deal Sheet",
  },
];

export default formsList;
